import { useQuery } from '@tanstack/react-query';

import { accountTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getAccounts: accountTypes.GetAccounts = () => {
  return axios.get('/accounts');
};

type QueryFnType = typeof getAccounts;

type UseGetAccountsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAccounts = ({ config = {} }: UseGetAccountsOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['accounts'],
    queryFn: getAccounts,
  });
};
